<div>
    <div class="">
        <p-tabMenu [model]="items" [(activeItem)]="activeTab" (activeItemChange)="onTabChange($event)"></p-tabMenu>

        <div class="tab-content mt-4">
            <!-- Tab General -->
            <div [ngStyle]="{ display: activeTabIndex === 0 ? 'block' : 'none' }">
                <form [formGroup]="form" appPermissionControl="P249F0001">
                    <div class="form-row">
                        <div class="form-field flex-grow-1">
                            <input pInputText type="text" formControlName="numero_actividad" class="form-control" [disabled]="model" appPermissionControl="P249K0001">
                            <label>N° Actividad</label>
                        </div>
                        <div class="form-field flex-grow-1">
                            <input pInputText type="text" formControlName="descripcion" class="form-control" appPermissionControl="P249K0002">
                            <label>Descripción</label>
                        </div>
                        <div class="form-field mt-1 flex-grow-1">
                            <p-dropdown appendTo="body" [options]="dependenciaOptions" optionLabel="label" [showClear]="true"
                                optionValue="value" formControlName="dependencia" placeholder="Seleccione dependencia"
                                [filter]="true" appPermissionControl="P249K0003"></p-dropdown>
                            <label>Dependencia</label>
                        </div>
                    </div>

                    <ng-container [ngSwitch]="casoActual">
                        <div class="form-row" *ngSwitchCase="'asigna'">
                            <div class="form-field flex-grow-1 mt-1">
                                <p-dropdown appendTo="body" [options]="tipoActividadOptions" optionLabel="label" [showClear]="true"
                                    optionValue="value" formControlName="tipo_actividad"
                                    placeholder="Seleccione tipo de actividad" [filter]="true" [disabled]="true" appPermissionControl="P249K0004"></p-dropdown>
                                <label>Tipo de Actividad</label>
                            </div>
                            <div class="form-field flex-grow-1">
                                <input type="text" class="form-control" [value]="decisionTexto" disabled placeholder="Decisión" appPermissionControl="P249K0005">
                                <label>Decisión</label>
                            </div>
                        </div>
                        <div class="form-row" *ngSwitchCase="'autorizada'">
                            <div class="form-field flex-grow-1">
                                <p-dropdown appendTo="body" [options]="motivosOptions" optionLabel="label" [showClear]="true" [filter]="true"
                                    optionValue="value" formControlName="motivo"
                                    placeholder="Seleccione motivo" appPermissionControl="P249K0006"></p-dropdown>
                                <label>Motivo</label>
                            </div>
                        </div>
                        <div class="form-row" *ngSwitchCase="'cancelada'">
                            <div class="form-field flex-grow-1">
                                <p-dropdown appendTo="body" [options]="motivosOptions" optionLabel="label" [showClear]="true" [filter]="true"
                                    optionValue="value" formControlName="motivo"
                                    placeholder="Seleccione motivo" appPermissionControl="P249K0007"></p-dropdown>
                                <label>Motivo</label>
                            </div>
                        </div>
                        <div class="form-row" *ngSwitchCase="'devolucion'">
                            <div class="form-field flex-grow-1">
                                <p-dropdown appendTo="body" [options]="motivosOptions" optionLabel="label" [showClear]="true" [filter]="true"
                                    optionValue="value" formControlName="motivo"
                                    placeholder="Seleccione motivo" appPermissionControl="P249K0008"></p-dropdown>
                                <label>Motivo</label>
                            </div>
                        </div>
                        <div class="form-row" *ngSwitchCase="'proceso'">
                            <div class="form-field flex-grow-1">
                                <p-dropdown appendTo="body" [options]="motivosOptions" optionLabel="label" [showClear]="true" [filter]="true"
                                    optionValue="value" formControlName="motivo"
                                    placeholder="Seleccione motivo" appPermissionControl="P249K0009"></p-dropdown>
                                <label>Motivo</label>
                            </div>
                        </div>
                        <div class="form-row" *ngSwitchCase="'rechazada'">
                            <div class="form-field flex-grow-1">
                                <p-dropdown appendTo="body" [options]="motivosOptions" optionLabel="label" [showClear]="true" [filter]="true"
                                    optionValue="value" formControlName="motivo"
                                    placeholder="Seleccione motivo" appPermissionControl="P249K0010"></p-dropdown>
                                <label>Motivo</label>
                            </div>
                        </div>
                        <div class="form-row" *ngSwitchCase="'repburo'">
                            <div class="form-field flex-grow-1 mt-1">
                                <p-dropdown appendTo="body" [options]="tipoActividadOptions" optionLabel="label" [showClear]="true"
                                    optionValue="value" formControlName="tipo_actividad"
                                    placeholder="Seleccione tipo de actividad" [filter]="true" [disabled]="true" appPermissionControl="P249K0011"></p-dropdown>
                                <label>Tipo de Actividad</label>
                            </div>
                            <div class="form-field flex-grow-1">
                                <input type="text" class="form-control" [value]="repBuroDecisionTexto" disabled placeholder="Decisión" appPermissionControl="P249K0012">
                                <label>Decisión</label>
                            </div>
                        </div>
                        <div class="form-row" *ngSwitchCase="'tipoActividad'">
                            <div class="form-field flex-grow-1">
                                <p-dropdown appendTo="body" [options]="tipoActividadOptions" optionLabel="label" [showClear]="true"
                                    optionValue="value" formControlName="tipo_actividad"
                                    placeholder="Seleccione tipo de actividad" [filter]="true" appPermissionControl="P249K0013"></p-dropdown>
                                <label>Tipo de Actividad</label>
                            </div>
                            <div class="form-field flex-grow-1" *ngIf="form.get('tipo_actividad')?.value === 'Decision'">
                                <input pInputText type="text" formControlName="decision" class="form-control" appPermissionControl="P249K0014">
                                <label>Decisión</label>
                            </div>
                        </div>
                        <div class="form-row" *ngSwitchCase="'buroext'">
                            <div class="form-field flex-grow-1 mt-1">
                                <p-dropdown appendTo="body" [options]="tipoActividadOptions" optionLabel="label" [showClear]="true"
                                    optionValue="value" formControlName="tipo_actividad"
                                    placeholder="Seleccione tipo de actividad" [filter]="true" [disabled]="true" appPermissionControl="P249K0015"></p-dropdown>
                                <label>Tipo de Actividad</label>
                            </div>
                            <div class="form-field flex-grow-1">
                                <input type="text" class="form-control" [value]="buroextDecisionTexto" disabled placeholder="Decisión" appPermissionControl="P249K0016">
                                <label>Decisión</label>
                            </div>
                        </div>
                        <div class="form-row" *ngSwitchCase="'buroint'">
                            <div class="form-field flex-grow-1 mt-1">
                                <p-dropdown appendTo="body" [options]="tipoActividadOptions" optionLabel="label" [showClear]="true"
                                    optionValue="value" formControlName="tipo_actividad"
                                    placeholder="Seleccione tipo de actividad" [filter]="true" [disabled]="true" appPermissionControl="P249K0017"></p-dropdown>
                                <label>Tipo de Actividad</label>
                            </div>
                            <div class="form-field flex-grow-1">
                                <input type="text" class="form-control" [value]="burointDecisionTexto" disabled placeholder="Decisión" appPermissionControl="P249K0018">
                                <label>Decisión</label>
                            </div>
                        </div>
                        <div class="form-row" *ngSwitchCase="'calbext'">
                            <div class="form-field flex-grow-1 mt-1">
                                <p-dropdown appendTo="body" [options]="tipoActividadOptions" optionLabel="label" [showClear]="true"
                                    optionValue="value" formControlName="tipo_actividad"
                                    placeholder="Seleccione tipo de actividad" [filter]="true" [disabled]="true" appPermissionControl="P249K0019"></p-dropdown>
                                <label>Tipo de Actividad</label>
                            </div>
                            <div class="form-field flex-grow-1">
                                <input type="text" class="form-control" [value]="calbextDecisionTexto" disabled placeholder="Decisión" appPermissionControl="P249K0020">
                                <label>Decisión</label>
                            </div>
                        </div>
                        <div class="form-row" *ngSwitchCase="'calbint'">
                            <div class="form-field flex-grow-1 mt-1">
                                <p-dropdown appendTo="body" [options]="tipoActividadOptions" optionLabel="label" [showClear]="true"
                                    optionValue="value" formControlName="tipo_actividad"
                                    placeholder="Seleccione tipo de actividad" [filter]="true" [disabled]="true" appPermissionControl="P249K0021"></p-dropdown>
                                <label>Tipo de Actividad</label>
                            </div>
                            <div class="form-field flex-grow-1">
                                <input type="text" class="form-control" [value]="calbextDecisionTexto" disabled placeholder="Decisión" appPermissionControl="P249K0022">
                                <label>Decisión</label>
                            </div>
                        </div>
                        <div class="form-row" *ngSwitchCase="'chcklst'">
                            <div class="form-field flex-grow-1 mt-1">
                                <p-dropdown appendTo="body" [options]="tipoActividadOptions" optionLabel="label" [showClear]="true"
                                    optionValue="value" formControlName="tipo_actividad"
                                    placeholder="Seleccione tipo de actividad" [filter]="true" [disabled]="true" appPermissionControl="P249K0023"></p-dropdown>
                                <label>Tipo de Actividad</label>
                            </div>
                            <div class="form-field flex-grow-1">
                                <input type="text" class="form-control" [value]="chcklistDecisionTexto" disabled placeholder="Decisión" appPermissionControl="P249K0024">
                                <label>Decisión</label>
                            </div>
                        </div>
                        <div class="form-row" *ngSwitchCase="'checklist'">
                            <div class="form-field flex-grow-1 mt-1">
                                <p-dropdown appendTo="body" [options]="checklistOptions" optionLabel="label" [showClear]="true"
                                    optionValue="value" formControlName="tipo_actividad"
                                    placeholder="Seleccione CheckList" [filter]="true" appPermissionControl="P249K0025"></p-dropdown>
                                <label>CheckList</label>
                            </div>
                            <div class="form-field flex-grow-1">
                                <input type="text" class="form-control" [value]="chcklistDecisionTexto" disabled placeholder="Decisión" appPermissionControl="P249K0026">
                                <label>Decisión</label>
                            </div>
                        </div>
                        <div class="form-row" *ngSwitchCase="'documento'">
                            <div class="form-field flex-grow-1 mt-1">
                                <p-dropdown appendTo="body" [options]="documentoOptions" optionLabel="label" [showClear]="true"
                                    optionValue="value" formControlName="tipo_actividad"
                                    placeholder="Seleccione Documento" [filter]="true" appPermissionControl="P249K0027"></p-dropdown>
                                <label>Documento</label>
                            </div>
                            <div class="form-field flex-grow-1">
                                <input type="text" class="form-control" [value]="documentoDecisionTexto" disabled placeholder="Decisión" appPermissionControl="P249K0028">
                                <label>Decisión</label>
                            </div>
                        </div>
                        <div class="form-row" *ngSwitchCase="'estatus'">
                            <div class="form-field flex-grow-1 mt-1">
                                <p-dropdown appendTo="body" [options]="tipoActividadOptions" optionLabel="label" [showClear]="true"
                                    optionValue="value" formControlName="tipo_actividad"
                                    placeholder="Seleccione tipo de actividad" [filter]="true" [disabled]="true" appPermissionControl="P249K0029"></p-dropdown>
                                <label>Tipo de Actividad</label>
                            </div>
                            <div class="form-field flex-grow-1">
                                <input type="text" class="form-control" [value]="estatusDecisionTexto" disabled placeholder="Decisión" appPermissionControl="P249K0030">
                                <label>Decisión</label>
                            </div>
                        </div>
                        <div class="form-row" *ngSwitchCase="'pantvar'">
                            <div class="form-field flex-grow-1 mt-1">
                                <p-dropdown appendTo="body" [options]="pantVarOptions" optionLabel="label" [showClear]="true"
                                    optionValue="value" formControlName="tipo_actividad"
                                    placeholder="Seleccione Pantalla" [filter]="true" appPermissionControl="P249K0031"></p-dropdown>
                                <label>Pantalla</label>
                            </div>
                        </div>
                        <div class="form-row" *ngSwitchCase="'vercheck'">
                            <div class="form-field flex-grow-1 mt-1">
                                <p-dropdown appendTo="body" [options]="pantVarOptions" optionLabel="label" [showClear]="true"
                                    optionValue="value" formControlName="tipo_actividad"
                                    placeholder="Seleccione Pantalla" [filter]="true" appPermissionControl="P249K0032"></p-dropdown>
                                <label>Pantalla</label>
                            </div>
                        </div>
                        <div class="form-row" *ngSwitchCase="'texto'">
                            <div class="form-field flex-grow-1 mt-1">
                                <p-dropdown appendTo="body" [options]="reportes" optionLabel="label" [showClear]="true"
                                    optionValue="value" formControlName="tipo_actividad"
                                    placeholder="Seleccione Texto" [filter]="true" appPermissionControl="P249K0033"></p-dropdown>
                                <label>Texto</label>
                            </div>
                        </div>
                        <div class="form-row" *ngSwitchCase="'pop'">
                            <div class="form-field flex-grow-1 mt-1">
                                <p-dropdown appendTo="body" [options]="campoOptions" optionLabel="label" [showClear]="true"
                                    optionValue="value" formControlName="campo"
                                    placeholder="Seleccione Campo" [filter]="true" appPermissionControl="P249K0034"></p-dropdown>
                                <label>Campo</label>
                            </div>
                            <div class="form-field flex-grow-1 mt-1">
                                <p-dropdown appendTo="body" [options]="variableOptions" optionLabel="label" [showClear]="true"
                                    optionValue="value" formControlName="variable"
                                    placeholder="Seleccione Variable" [filter]="true" appPermissionControl="P249K0035"></p-dropdown>
                                <label>Variable</label>
                            </div>
                        </div>
                    </ng-container>

                    <h3>Tiempo estimado</h3>
                    <div class="form-row">
                        <div class="form-field">
                            <input pInputText type="number" min="0" formControlName="dias" class="form-control" appPermissionControl="P249K0036">
                            <label>Días</label>
                        </div>
                        <div class="form-field">
                            <input pInputText type="number" min="0" max="23" formControlName="horas"
                                class="form-control" appPermissionControl="P249K0037">
                            <label>Hora</label>
                        </div>
                        <div class="form-field">
                            <input pInputText type="number" min="0" max="59" formControlName="minutos"
                                class="form-control" appPermissionControl="P249K0038">
                            <label>Minutos</label>
                        </div>
                        <div class="form-field">
                            <input pInputText type="number" min="0" formControlName="costo_estimado"
                                class="form-control" appPermissionControl="P249K0039">
                            <label>Costo estimado</label>
                        </div>
                    </div>
                    <h3>Periodo de Trabajo</h3>
                    <div class="form-row align-items-center">
                        <ng-container *ngFor="let dia of diasSemana; let i = index">
                            <input type="checkbox" [checked]="diasSeleccionados[i]"
                                (change)="onDiaSemanaChange(i, $event.target.checked)" style="margin-right: 0.5rem;" appPermissionControl="P249K0040">
                            <span style="margin-right: 1.5rem;">{{ dia.label }}</span>
                        </ng-container>
                    </div>
                </form>
            </div>

            <!-- Tab Acción a Tomar -->
            <div [ngStyle]="{ display: activeTabIndex === 1 ? 'block' : 'none' }">
                <form [formGroup]="accionForm" class="mt-3" appPermissionControl="P249F0002">
                    <div class="form-row">
                        <div class="form-field">
                            <p-dropdown appendTo="body" class="w-100" formControlName="cuestionario"
                                [options]="cuestionarios" optionLabel="name" optionValue="value" [filter]="true"
                                [showClear]="true" placeholder="-- Seleccione Cuestionario --" appPermissionControl="P249K0041">
                                <ng-template let-item pTemplate="item">
                                    <div class="dropdown-item">{{ item.name }}</div>
                                </ng-template>
                            </p-dropdown>
                            <label>Cuestionario</label>
                        </div>
                        <div class="form-field">
                            <p-dropdown appendTo="body" class="w-100" formControlName="clave" [options]="claves"
                                optionLabel="name" optionValue="value" [filter]="true" [showClear]="true"
                                placeholder="-- Seleccione Clave --" (onChange)="onClaveChange($event)" appPermissionControl="P249K0042">
                                <ng-template let-item pTemplate="item">
                                    <div class="dropdown-item">{{ item.name }}</div>
                                </ng-template>
                            </p-dropdown>
                            <label>Clave</label>
                        </div>
                    </div>
                </form>
            </div>

            <!-- Tab Responsable -->
            <div [ngStyle]="{ display: activeTabIndex === 2 ? 'block' : 'none' }">
                <form [formGroup]="responsableForm" class="mt-3" appPermissionControl="P249F0003">
                    <div class="form-row">
                        <div class="form-field">
                            <p-dropdown appendTo="body" class="w-100" formControlName="accion" [options]="acciones"
                                optionLabel="name" optionValue="value" [filter]="true" [showClear]="true"
                                placeholder="-- Seleccione Acción --" appPermissionControl="P249K0043">
                                <ng-template let-item pTemplate="item">
                                    <div class="dropdown-item">{{ item.name }}</div>
                                </ng-template>
                            </p-dropdown>
                            <label>Acción</label>
                        </div>
                        <div class="form-field" *ngIf="responsableForm.get('accion')?.value === 'NONE'">
                            <p-dropdown appendTo="body" class="w-100" formControlName="responsable"
                                [options]="responsables" optionLabel="name" optionValue="value" [filter]="true"
                                [showClear]="true" placeholder="-- Seleccione Responsable --" [loading]="loading"
                                styleClass="w-full" appPermissionControl="P249K0044">
                                <ng-template let-item pTemplate="item">
                                    <div class="dropdown-item">{{ item.name }}</div>
                                </ng-template>
                            </p-dropdown>
                            <label>Responsable</label>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div class="card-footer">
        <div class="d-flex justify-content-end gap-2">
            <button mat-flat-button class="btn-search btn-menu" *ngIf="model" (click)="abrirRenumerarDialog()" appPermissionControl="P249B0001">
                <mat-icon>refresh</mat-icon>
                Renumerar
            </button>
            <button mat-flat-button class="btn-success btn-menu" (click)="aceptar()" appPermissionControl="P249B0002">
                <mat-icon>save</mat-icon>
                {{ model ? "Actualizar" : "Guardar" }}
            </button>
        </div>
    </div>
</div>

<!-- Diálogo de Renumerar -->
<p-dialog header="Renumerar Actividad" [(visible)]="displayRenumerarDialog" [modal]="true" [style]="{width: '350px'}" [closable]="true" (onHide)="cerrarRenumerarDialog()">
  <form [formGroup]="renumerarForm" (ngSubmit)="guardarRenumerar()" appPermissionControl="P249F0004">
    <div class="form-row">
      <div class="form-field">
        <input pInputText type="text" formControlName="origen" class="form-control" disabled appPermissionControl="P249K0045">
        <label>Origen</label>
      </div>
      <div class="form-field">
        <input pInputText type="number" formControlName="destino" class="form-control" required min="1" appPermissionControl="P249K0046">
        <label>Destino</label>
      </div>
    </div>
    <div class="button-section mt-3" style="justify-content: flex-end;">
      <button mat-flat-button class="btn-success btn-menu" type="submit" appPermissionControl="P249B0003">
        <mat-icon>save</mat-icon>
        Guardar
      </button>
    </div>
  </form>
</p-dialog>

<style>
    :host ::ng-deep .p-dropdown {
        width: 100%;
        height: 37px;
    }

    :host ::ng-deep .p-dropdown-panel {
        width: 100%;
    }

    :host ::ng-deep .p-dropdown-filter {
        width: 100%;
        padding: 0.5rem;
    }

    :host ::ng-deep .p-dropdown .p-dropdown-label {
        font-size: 12px !important;
    }

    :host ::ng-deep .p-dropdown .p-dropdown-label.p-placeholder {
        font-size: 12px !important;
    }

    .dropdown-item {
        font-size: 12px;
        padding: 4px;
    }

    :host ::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item {
        padding: 0.5rem;
        font-size: 12px;
    }

    :host ::ng-deep .p-dropdown-panel .p-dropdown-header .p-dropdown-filter {
        padding: 0.5rem;
        font-size: 12px;
    }

    :host ::ng-deep .p-dropdown-panel .p-dropdown-header {
        padding: 0.5rem;
    }

    :host ::ng-deep .p-dropdown-panel .p-dropdown-items {
        padding: 0;
    }

    :host ::ng-deep .p-dropdown .p-dropdown-clear-icon {
        right: 2.5rem;
    }

    :host ::ng-deep .p-dropdown .p-dropdown-trigger {
        width: 2rem;
    }

    .card-footer {
        padding: 1rem;
        border-top: 1px solid #dee2e6;
    }

    .gap-2 {
        gap: 0.5rem;
    }

    .empty-tab-content {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 200px;
        background-color: #f8f9fa;
        border-radius: 4px;
        border: 1px dashed #dee2e6;
    }

    .text-muted {
        color: #6c757d;
    }

    .text-center {
        text-align: center;
    }

    :host ::ng-deep .p-tabmenu .p-tabmenu-nav .p-tabmenuitem .p-menuitem-link {
        background: #f8f9fa;
        border: 1px solid #dee2e6;
        border-radius: 4px 4px 0 0;
        padding: 0.75rem 1.25rem;
        font-weight: 500;
        color: #6c757d;
        transition: all 0.2s;
        text-decoration: none;
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }

    :host ::ng-deep .p-tabmenu .p-tabmenu-nav .p-tabmenuitem .p-menuitem-link:not(.p-disabled):focus {
        box-shadow: none;
    }

    :host ::ng-deep .p-tabmenu .p-tabmenu-nav .p-tabmenuitem .p-menuitem-link:hover {
        background: #e9ecef;
        border-color: #dee2e6;
        color: #495057;
    }

    :host ::ng-deep .p-tabmenu .p-tabmenu-nav .p-tabmenuitem.p-highlight .p-menuitem-link {
        background: #fff;
        border-color: #dee2e6;
        color: #007bff;
        position: relative;
    }

    :host ::ng-deep .p-tabmenu .p-tabmenu-nav .p-tabmenuitem.p-highlight .p-menuitem-link::after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 0;
        right: 0;
        height: 2px;
        background: #fff;
    }

    .form-row {
        margin-bottom: 0;
    }
</style>